export default __webpack_public_path__ + "static/a2138aaebfbdab81b699f4d965f3f1a5.webp";